import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addSupportNote,
  fetchSupportReport,
  fetchSupportReports,
  updateSupportReport,
} from "../api/supportApi";
import type { SupportReportsQuery, UpdateSupportReportPatch } from "../types";

const REPORTS_KEY = ["support-reports"];

export const useSupportReportsQuery = (query: SupportReportsQuery) =>
  useQuery({
    queryKey: [...REPORTS_KEY, query],
    queryFn: () => fetchSupportReports(query),
  });

export const useSupportReportQuery = (id: string | null) =>
  useQuery({
    queryKey: [...REPORTS_KEY, "detail", id],
    queryFn: () => fetchSupportReport(id!),
    enabled: !!id,
  });

export const useUpdateSupportReport = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      patch,
    }: {
      id: string;
      patch: UpdateSupportReportPatch;
    }) => updateSupportReport(id, patch),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: REPORTS_KEY });
    },
  });
};

export const useAddSupportNote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, text }: { id: string; text: string }) =>
      addSupportNote(id, text),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: REPORTS_KEY });
    },
  });
};
